<script lang="ts">
	import { Input } from "flowbite-svelte";
	import { onMount } from "svelte";
	import Icon from "#lib/components/Icon.svelte";
	import ToolbarButton from "#lib/components/content-editors/toolbar/ToolbarButton.svelte";

	interface Props {
		linkUrl: string;
		linkText: string;
		justSettingUrl?: boolean;
		onSubmit: (url: string, text: string) => void;
		onRemove: () => void;
	}

	let { linkText = $bindable(), linkUrl = $bindable(), onSubmit, onRemove, justSettingUrl = false }: Props = $props();

	function handleSubmit() {
		onSubmit(linkUrl, linkText);
	}

	function handleTrash() {
		onRemove();
	}

	onMount(() => {
		if (justSettingUrl) {
			document.getElementById("link-url-input-set")?.focus();
		} else if (!linkUrl) {
			// focus on the URL input
			document.getElementById("link-url-input-edit")?.focus();
		} else {
			// focus on the text input
			document.getElementById("link-text-input")?.focus();
		}
	});
</script>

{#if justSettingUrl}
	<div class="ml-2 flex min-w-64 items-center gap-2">
		<Icon height="16px" name="link" />
		<Input size="md" type="url" name="url" id="link-url-input-set" placeholder="https://www.example.com" required bind:value={linkUrl} />
		<ToolbarButton data-action-name="link-editor-submit" onclick={handleSubmit}><Icon height="16px" name="check" /></ToolbarButton>
	</div>
{:else}
	<div class="flex min-w-64 flex-col gap-2">
		<div class="flex items-center gap-x-2">
			<Icon height="16px" name="bars-3-bottom-left" />
			<Input size="md" type="text" name="text" id="link-text-input" placeholder="Type link text" required bind:value={linkText} />
		</div>
		<div class="flex items-center gap-x-2">
			<Icon height="16px" name="link" />
			<Input size="md" type="url" name="url" id="link-url-input-edit" placeholder="https://www.example.com" required bind:value={linkUrl} />
		</div>
	</div>
	<div class="ml-2 flex justify-end">
		<ToolbarButton data-action-name="link-editor-submit" onclick={handleSubmit}><Icon height="16px" name="check" /></ToolbarButton>
		<ToolbarButton data-action-name="link-editor-delete" onclick={handleTrash}><Icon height="16px" name="trash" /></ToolbarButton>
	</div>
{/if}
